// @flow
import React from 'react';
import type {Node} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {logout} from '../../redux/actions/login-actions';
import styles from './Header.module.css';
import translate from '../../config/text';
import type {TranslateType} from '../../types';
import logo from '../../assets/CA_anniversary_logo.svg';

type StatusType = {
  isLoggedIn: boolean,
  firstName: string,
  language: string,
};


const Header = ({
  status,
  logout,
}: {status: StatusType, logout: () => void}): Node => {
  const t = translate(status.language);
  if (status.isLoggedIn){
      return (
          <div className={styles.header}>
              <div>
                  <div className={styles.headerLinks}>
                      <Link to="/dashboard" className={styles.logo}>
                          <img className={styles.abc} src={logo} alt={`Cambridge audio `} />
                          <div className={`${styles.logoTitle} fontBrown`}>
                              {t('title')}
                          </div>
                      </Link>
                      <div className={styles.twoLinks}>
                          <Link className={styles.rightLink} to='/courses'>Courses</Link>
                          <Link className={styles.rightLink} to='/resources'>Resources</Link>
                      </div>
                  </div>
                  <User
                      isLoggedIn={status.isLoggedIn}
                      firstName={status.firstName}
                      logout={logout}
                      t={t} />
              </div>
          </div>
      );
  }else{
      return (
          null
      );
  }
};

type UserType = {
  isLoggedIn: boolean,
  firstName: string,
  logout: () => void,
  t: TranslateType,
};

const User = ({
  isLoggedIn,
  firstName,
  logout,
  t,
}: UserType): Node => (
  <div className={styles.user}>
    {
      isLoggedIn
        ? <LoggedIn t={t} firstName={firstName} logout={logout} />
        : <LoggedOut t={t} />
    }
  </div>
);


const LoggedOut = ({t}: {t: TranslateType}): Node => (

    <div className={styles.headerLink}>
        <input className={styles.toggle} id="toggle" type="checkbox" />
        <label className={styles.burger} htmlFor="toggle">
            <div>
            </div>
            <div>
            </div>
            <div>
            </div>
        </label>
        <div className={styles.slideMenu}>
            <h4>Menu</h4>
            <nav className={styles.menu}>
                <Link className={styles.menuLink} to="/register">{t('register')}</Link>
                <Link className={styles.menuLink} to="/login">{t('signIn')}</Link>
            </nav>
        </div>
    </div>
);

const LoggedIn = ({
  logout,
  firstName,
  t,
}: {logout: () => void, firstName: string, t: TranslateType}): Node => (
        <div className={styles.headerLink}>
            <input className={styles.toggle} id="toggle" type="checkbox" />
            <label className={styles.burger} htmlFor="toggle">
                <div>
                </div>
                <div>
                </div>
                <div>
                </div>
            </label>
                <div className={styles.slideMenu}>

                    <nav className={styles.menu}>
                        <Link className={styles.menuLink} to="/dashboard">{t('home')}</Link>
                        <Link className={styles.menuLink} to="/courses">{t('courses')}</Link>
                        <Link className={styles.menuLink} to="/resources">{t('resources')}</Link>
                        <Link className={styles.menuLink} to="/profile">{t('yourProfile')}</Link>
                        <Link className={styles.menuLink} to="/language">{t('language')}</Link>
                        <button className={`${styles.logout} ${styles.menuLink}`} onClick={(): void => logout()}>
                            {t('signOut')}
                        </button>
                    </nav>
                </div>
        </div>
);

const mapStateToProps = (state: any): any => ({
  status: state.status,
});

const mapDispatchToProps = (dispatch: any): any => ({
  logout: (): void => dispatch(logout()),
});

const HeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);

export default HeaderContainer;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js